import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';

export interface IDeletePropsSDKProps {
  deleted: boolean;
}

export interface IDeletePropsSDK {
  delete: () => void;
  restore: () => void;
}

export interface IDeletePropsSDKActions {
  delete: () => void;
  restore: () => void;
  deleted: boolean;
}

export const deletePropsSDKFactory: CorvidSDKPropsFactory<
  IDeletePropsSDKProps,
  IDeletePropsSDK
> = api => ({
  delete: () => {
    api.setProps({ deleted: true });
    api.remove();
  },
  restore: () => {
    api.setProps({ deleted: false });
    api.restore();
  },
  get deleted() {
    return !!api.props.deleted;
  },
});
